import { useRef, useEffect, useState } from "react";
import "../styles/MiniProfile.css";
import logo from "../images/txtlogo.png";
import share from "../images/share.gif"
import api from "./api.js"
import html2canvas from "html2canvas";
import { Modal, Spinner } from 'react-bootstrap';
const MiniProfile = () => {
    const exportRef = useRef();
    const [studentData, setStudentData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [exportMode, setExportMode] = useState(false);
    const [isSharing, setIsSharing] = useState(false);
    const [showProcessing, setShowProcessing] = useState(false); // استیت جدید برای نمایش فوری
    const [shareError, setShareError] = useState(null);
// تابع کمکی برای تبدیل URL به Base64
const imageToBase64 = (url) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous'; // مهم
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = reject;
        img.src = url;
    });
};
    const studentProfileAPI = {
        getStudentScores: async (id) => {
            try {
                const res = await api.get(`/student/api/v1/student-scores/me/`);
                return res.data;
            } catch (error) {
                console.error("خطا در دریافت اطلاعات امتیازات:", error);
                throw error;
            }
        }
    };

    const resetSharingState = () => {
        setIsSharing(false);
        setShowProcessing(false);
        setShareError(null);
    };

const renderUserFace = () => {
    const imageSrc = studentData?.my_score?.profile_image_base64 || studentData?.my_score?.profile_image;
    
    if (imageSrc) {
        return (
            <svg width="165" height="165" viewBox="0 0 527 593" fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <clipPath id="hexagonClip">
                        <path d="M240.271 10.1621C254.504 1.94514 272.039 1.94513 286.271 10.1621L499.543 133.295C513.775 141.512 522.543 156.698 522.543 173.132V419.397C522.543 435.832 513.775 451.017 499.543 459.234L286.271 582.367C272.039 590.584 254.504 590.584 240.271 582.367L27 459.234C12.7677 451.017 4.00012 435.832 4 419.397V173.132C4.00012 156.698 12.7676 141.512 27 133.295L240.271 10.1621Z" />
                    </clipPath>
                    <linearGradient id="paint0_linear_2730_7232" x1="133.691" y1="71.3046" x2="395.131" y2="514.005" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#20A563" />
                        <stop offset="1" stopColor="#F76450" />
                    </linearGradient>
                </defs>
                <image
                    href={imageSrc}
                    width="527"
                    height="593"
                    clipPath="url(#hexagonClip)"
                    preserveAspectRatio="xMidYMid slice"
                />
                <path
                    d="M240.271 10.1621C254.504 1.94514 272.039 1.94513 286.271 10.1621L499.543 133.295C513.775 141.512 522.543 156.698 522.543 173.132V419.397C522.543 435.832 513.775 451.017 499.543 459.234L286.271 582.367C272.039 590.584 254.504 590.584 240.271 582.367L27 459.234C12.7677 451.017 4.00012 435.832 4 419.397V173.132C4.00012 156.698 12.7676 141.512 27 133.295L240.271 10.1621Z"
                    fill="transparent"
                    stroke="url(#paint0_linear_2730_7232)"
                    strokeWidth="8"
                />
            </svg>
        );
    } else {
         return (
            <svg width="165" height="165" viewBox="0 0 527 593" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <path d="M240.271 10.1621C254.504 1.94514 272.039 1.94513 286.271 10.1621L499.543 133.295C513.775 141.512 522.543 156.698 522.543 173.132V419.397C522.543 435.832 513.775 451.017 499.543 459.234L286.271 582.367C272.039 590.584 254.504 590.584 240.271 582.367L27 459.234C12.7677 451.017 4.00012 435.832 4 419.397V173.132C4.00012 156.698 12.7676 141.512 27 133.295L240.271 10.1621Z" fill="url(#pattern0_2730_7232)" stroke="url(#paint0_linear_2730_7232)" strokeWidth="8" />
                <defs>
                    <pattern id="pattern0_2730_7232" patternContentUnits="objectBoundingBox" width="1" height="1">
                        <use xlinkHref="#image0_2730_7232" transform="translate(-0.416667) scale(0.000651042)" />
                    </pattern>
                    <linearGradient id="paint0_linear_2730_7232" x1="133.691" y1="71.3046" x2="395.131" y2="514.005" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#20A563" />
                        <stop offset="1" stopColor="#F76450" />
                    </linearGradient>
                    <image id="image0_2730_7232" width="2816" height="1536" preserveAspectRatio="none"  />
                </defs>
            </svg>
        );
    }
};

    const handleShareError = (error) => {
        console.error("خطا در اشتراک‌گذاری:", error);
        setShareError("مشکلی در اشتراک‌گذاری رخ داد. لطفاً مجدداً تلاش کنید.");
        setIsSharing(false);
        setShowProcessing(false);
    };

   useEffect(() => {
    const fetchScores = async () => {
        try {
            const data = await studentProfileAPI.getStudentScores(1);
            
            // اگر تصویر وجود داشت، آن را به Base64 تبدیل کن
            if (data?.my_score?.profile_image) {
                try {
                    const base64Image = await imageToBase64(data.my_score.profile_image);
                    data.my_score.profile_image_base64 = base64Image;
                } catch (e) {
                    console.log('خطا در تبدیل تصویر:', e);
                }
            }
            
            setStudentData(data);
        } catch (error) {
            console.error("خطا در دریافت داده‌ها");
        } finally {
            setLoading(false);
        }
    };
    fetchScores();
}, []);
    const downloadImage = (canvas) => {
        return new Promise((resolve, reject) => {
            try {
                const link = document.createElement('a');
                link.download = `mini-profile-${studentData?.my_score?.full_name || 'user'}.png`;
                link.href = canvas.toDataURL('image/png');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    };

    const handleShare = async () => {
        if (!exportRef.current || isSharing) return;

        // 🔥 نمایش فوری پیام "در حال پردازش"
        setShowProcessing(true);
        setIsSharing(true);
        setShareError(null);

        // استفاده از setTimeout برای اطمینان از رندر شدن پیام
        await new Promise(resolve => setTimeout(resolve, 50));

        try {
            const canvas = await html2canvas(exportRef.current, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: null,
                logging: false,
            });

            const blob = await new Promise((resolve, reject) => {
                canvas.toBlob((blob) => {
                    if (blob) {
                        resolve(blob);
                    } else {
                        reject(new Error("دریافت تصویر با شکست مواجه شد"));
                    }
                }, 'image/png', 0.9);
            });

            const file = new File(
                [blob],
                `mini-profile-${studentData?.my_score?.full_name || 'user'}.png`,
                { type: 'image/png' }
            );

            if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
                try {
                    await navigator.share({
                        files: [file],
                        title: 'مینی پروفایل',
                        text: `پروفایل ${studentData?.my_score?.full_name || ''}`,
                    });
                } catch (shareError) {
                    if (shareError.name !== 'AbortError') {
                        await downloadImage(canvas);
                    }
                }
            } else {
                await downloadImage(canvas);
            }

            resetSharingState();

        } catch (error) {
            handleShareError(error);
        }
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <div className="spinner-border text-success" role="status">
                    <span className="visually-hidden">در حال بارگذاری...</span>
                </div>
            </div>
        );
    }
    return (
        <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: "100vh" }}>

            <div ref={exportRef} className="mini-container">
                <div className="d-flex justify-content-center w-100">
                    <div className="py-3">
                        <img src={logo} width={120} />
                    </div>
                </div>
                <div className="profile-mini">
                    
                </div>
                <div className="card-mini">

                   
                </div>
                <div className="d-flex p-relative justify-content-center" style={{ position: "relative" }}>
                    <svg width="200" height="200" viewBox="0 0 629 705" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_2730_7233)">
                            <path d="M292.448 31.8945C305.849 24.1575 322.311 24.037 335.808 31.5322L336.448 31.8945L580.896 173.027C594.51 180.887 602.896 195.412 602.896 211.132V493.397C602.896 509.117 594.51 523.642 580.896 531.502L336.448 672.635C322.835 680.495 306.062 680.495 292.448 672.635L48 531.502C34.3864 523.642 26.0001 509.117 26 493.397V211.132C26.0001 195.412 34.3865 180.887 48 173.027L292.448 31.8945Z" stroke="url(#paint0_linear_2730_7233)" strokeWidth="12" />
                        </g>
                        <defs>
                            <filter id="filter0_d_2730_7233" x="0" y="0" width="628.896" height="704.529" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset />
                                <feGaussianBlur stdDeviation="10" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0.968627 0 0 0 0 0.392157 0 0 0 0 0.313726 0 0 0 1 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2730_7233" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2730_7233" result="shape" />
                            </filter>
                            <linearGradient id="paint0_linear_2730_7233" x1="161.524" y1="102.198" x2="477.618" y2="597.399" gradientUnits="userSpaceOnUse">
                                <stop stopColor="#20A563" />
                                <stop offset="1" stopColor="#F76450" />
                            </linearGradient>
                        </defs>

                    </svg>
                    {/* <img src={boy} width={300} /> */}
                   <div className="user-face">
    {renderUserFace()}
</div>
                </div>

                <div className="d-flex justify-content-center" >
                    <div>
                        <span className="gradient-text fs-5 mt-4 bold"> {studentData?.my_score.full_name || ""}</span>
                    </div>
                </div>
                <div style={{ position: "relative" }}>
                    <div className="d-flex justify-content-center">
                        <svg width="480" height="240" viewBox="0 0 730 691" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_2730_7235)">
                                <rect x="25" y="25" width="680" height="641" rx="50" fill="white" />
                                <rect x="29" y="29" width="672" height="633" rx="46" stroke="url(#paint0_linear_2730_7235)" strokeWidth="8" />
                            </g>
                            <defs>
                                <filter id="filter0_d_2730_7235" x="0" y="0" width="730" height="691" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feMorphology radius="9" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_2730_7235" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="8" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 0.968627 0 0 0 0 0.392157 0 0 0 0 0.313726 0 0 0 0.25 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2730_7235" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2730_7235" result="shape" />
                                </filter>
                                <linearGradient id="paint0_linear_2730_7235" x1="76" y1="25" x2="790.211" y2="452.773" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#20A563" />
                                    <stop offset="1" stopColor="#F76450" />
                                </linearGradient>
                            </defs>
                        </svg>
                        <div>

                        </div>
                    </div>

                    <div className="d-flex justify-content-center " style={{ position: "absolute", top: "30px", right: "90px" }}>
                        <div>
                            <div>
                                <svg width="60" height="60" viewBox="0 0 136 136" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="3" y="3" width="130" height="130" rx="27" stroke="url(#paint0_linear_2730_7244)" strokeWidth="6" />
                                    <defs>
                                        <linearGradient id="paint0_linear_2730_7244" x1="136" y1="0" x2="1.62125e-05" y2="136" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#F76450" />
                                            <stop offset="1" stopColor="#20A563" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <div style={{ top: "5px", right: "5px", position: "absolute" }}>
                                    <svg width="50" height="50" viewBox="0 0 110 110" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M55 73.334V87.084" stroke="url(#paint0_linear_2730_7236)" strokeWidth="4" strokeLinecap="round" />
                                        <path d="M71.0423 100.833H38.959L40.5173 93.06C40.7249 92.0214 41.2858 91.0867 42.1047 90.4149C42.9235 89.7431 43.9498 89.3756 45.009 89.375H64.9923C66.0515 89.3756 67.0778 89.7431 67.8966 90.4149C68.7155 91.0867 69.2764 92.0214 69.484 93.06L71.0423 100.833Z" stroke="url(#paint1_linear_2730_7236)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M87.0837 22.917L91.4332 24.3653C95.9707 25.8778 98.2395 26.6341 99.5366 28.4353C100.834 30.2366 100.834 32.6337 100.834 37.4095V37.7441C100.834 41.6857 100.834 43.6612 99.8849 45.2745C98.9361 46.8878 97.2082 47.8457 93.7616 49.7662L80.2087 57.292M22.917 22.917L18.5674 24.3653C14.0299 25.8778 11.7612 26.6341 10.4641 28.4353C9.16699 30.2366 9.16699 32.6337 9.16699 37.4095V37.7441C9.16699 41.6857 9.16699 43.6612 10.1157 45.2745C11.0645 46.8878 12.7924 47.8457 16.2391 49.7662L29.792 57.292M51.0862 27.6057C52.8278 24.4753 53.6987 22.917 55.0003 22.917C56.302 22.917 57.1728 24.4753 58.9145 27.6057L59.3637 28.4124C59.8587 29.3016 60.1062 29.7416 60.4912 30.0349C60.8807 30.3282 61.362 30.4382 62.3245 30.6537L63.1953 30.8553C66.5778 31.6207 68.2691 32.0012 68.6724 33.2937C69.0757 34.5862 67.9207 35.9382 65.6153 38.6332L65.0195 39.3299C64.3641 40.0953 64.0341 40.4757 63.8874 40.9524C63.7407 41.4291 63.7912 41.9378 63.8874 42.9599L63.9791 43.8903C64.3274 47.4882 64.5016 49.2895 63.452 50.087C62.3978 50.8845 60.812 50.1557 57.6449 48.6982L56.8291 48.3224C55.9262 47.9099 55.477 47.7037 55.0003 47.7037C54.5237 47.7037 54.0745 47.9099 53.1716 48.3224L52.3557 48.6982C49.1887 50.1603 47.6028 50.8845 46.5487 50.087C45.4945 49.2895 45.6732 47.4882 46.0216 43.8903L46.1132 42.9599C46.2095 41.9378 46.2599 41.4291 46.1132 40.9524C45.9666 40.4757 45.6366 40.0953 44.9812 39.3299L44.3853 38.6332C42.0799 35.9382 40.9249 34.5907 41.3282 33.2937C41.7316 32.0012 43.4228 31.6207 46.8053 30.8553L47.6762 30.6537C48.6387 30.4382 49.1199 30.3328 49.5095 30.0349C49.8945 29.7416 50.142 29.3016 50.637 28.4124L51.0862 27.6057Z" stroke="url(#paint2_linear_2730_7236)" strokeWidth="4" />
                                        <path d="M82.5006 100.834H27.5006M77.9173 11.2571C81.3135 11.9033 83.3302 12.6183 85.0673 14.7633C87.2535 17.4492 87.1389 20.3504 86.9052 26.1529C86.0802 47.0208 81.4052 73.3337 55.0052 73.3337C28.6052 73.3337 23.9256 47.0254 23.0914 26.1529C22.8623 20.3504 22.7477 17.4446 24.9248 14.7633C27.1064 12.0775 29.7143 11.6375 34.9348 10.7575C41.5676 9.67097 48.2794 9.13899 55.0006 9.16707C58.2945 9.17318 61.35 9.27707 64.1673 9.47874" stroke="url(#paint3_linear_2730_7236)" strokeWidth="4" strokeLinecap="round" />
                                        <defs>
                                            <linearGradient id="paint0_linear_2730_7236" x1="55.5" y1="73.334" x2="55.5" y2="87.084" gradientUnits="userSpaceOnUse">
                                                <stop stopColor="#20A563" />
                                                <stop offset="1" stopColor="#F76450" />
                                            </linearGradient>
                                            <linearGradient id="paint1_linear_2730_7236" x1="55.0007" y1="89.375" x2="55.0007" y2="100.833" gradientUnits="userSpaceOnUse">
                                                <stop stopColor="#20A563" />
                                                <stop offset="1" stopColor="#F76450" />
                                            </linearGradient>
                                            <linearGradient id="paint2_linear_2730_7236" x1="55.0003" y1="22.917" x2="55.0003" y2="57.292" gradientUnits="userSpaceOnUse">
                                                <stop stopColor="#20A563" />
                                                <stop offset="1" stopColor="#F76450" />
                                            </linearGradient>
                                            <linearGradient id="paint3_linear_2730_7236" x1="54.9996" y1="9.16602" x2="54.9996" y2="100.834" gradientUnits="userSpaceOnUse">
                                                <stop stopColor="#20A563" />
                                                <stop offset="1" stopColor="#F76450" />
                                            </linearGradient>
                                        </defs>
                                    </svg>

                                </div>
                                <span className="px-3 fs-5">
                                    امتیاز :
                                    <span className={exportMode ? "orange-txt" : "gradient-text2"} > {studentData?.my_score.total_score || 0} </span>
                                </span>

                            </div>


                        </div>


                    </div>
                    <div style={{ position: "absolute", top: "90px", right: "90px" }}>
                        <svg width="194" height="6" viewBox="0 0 584 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="3" y1="3" x2="581" y2="3" stroke="url(#paint0_linear_2730_7245)" strokeWidth="6" strokeLinecap="round" />
                            <defs>
                                <linearGradient id="paint0_linear_2730_7245" x1="0" y1="6.5" x2="584" y2="6.5" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#20A563" />
                                    <stop offset="1" stopColor="#F76450" />
                                </linearGradient>
                            </defs>
                        </svg>
                        <div className="d-flex mb-2 justify-content-center">
                            دوره فعلی:
                        </div>
                        <div className="d-flex justify-content-center">
                            <img src={studentData?.my_score.last_class.certificate_category_logo || ""} width={50} />
                        </div>
                        <div className="d-flex mt-1 justify-content-center gradient-text" style={{ fontSize: "13px" }}>
                            {studentData?.my_score.last_class.course_name || ""}
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        www.PythonTeek.com
                    </div>
                </div>

            </div>
           <Modal show={isSharing} backdrop="static" keyboard={false} centered>
                <Modal.Body className="text-center py-4">
                    <Spinner animation="border" variant="success" className="mb-3" />
                    
                    {/* نمایش پیام فوری یا پیام خطا */}
                    {shareError ? (
                        <>
                            <p className="mb-0 text-danger">{shareError}</p>
                            <button 
                                className="btn btn-outline-danger btn-sm mt-3"
                                onClick={resetSharingState}
                            >
                                بستن
                            </button>
                        </>
                    ) : (
                        <>
                            <p className="mb-0">
                                {showProcessing ? "در حال پردازش..." : "لطفاً صبر کنید..."}
                            </p>
                            <small className="text-muted">
                                {showProcessing ? "در حال آماده‌سازی تصویر" : "لطفاً شکیبا باشید..."}
                            </small>
                        </>
                    )}
                </Modal.Body>
            </Modal>
            {/* دکمه اشتراک‌گذاری */}
              <button 
                onClick={handleShare} 
                disabled={isSharing}
                className="mt-3"
                style={{
                outline: "none",
                border: "none",
                backgroundColor: "#4CAF50",
                padding: "12px 30px",
                borderRadius: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                color: "white",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: "pointer",
                boxShadow: "0 2px 10px rgba(76, 175, 80, 0.3)",
                transition: "all 0.3s ease",
                width: "100%",
                maxWidth: "300px"
            }}
            > <img src={share} width={24} height={24} alt="share" style={{ filter: "brightness(0) invert(1)" }} />
                {isSharing ? 'در حال پردازش...' : 'اشتراک‌گذاری'}
            </button>
           
        </div>
    );
};

export default MiniProfile;